module.exports = __webpack_public_path__ + "assets/img/SRG-Finance-Pillar-Page-Resource-w720.fc7d1dc0.webp";